import { useNavigate } from 'react-router-dom';

const useMenuItemClick = (onItemSelected = null) => {
    const navigate = useNavigate();

    const handleItemClick = (urlToNavigate) => {
        navigate(urlToNavigate);
        if (onItemSelected) {
            onItemSelected();
        }
    };

    return handleItemClick;
};

export default useMenuItemClick;